import { Suspense, lazy, type ComponentType, type ReactElement } from 'react';

import { LoadingState } from '@/shared/components/States';

/**
 * Route-level code splitting.
 *
 * Each major application area is a separate chunk, so a branch requester
 * downloads the catalogue and their own requests — not the administration
 * console, the sourcing workspace or the reporting suite they can never open.
 *
 * The fallback is the same skeleton the pages use while their data loads, so a
 * chunk fetch looks like any other loading state rather than a blank screen.
 */
export function lazyRoute(
  loader: () => Promise<Record<string, ComponentType>>,
  exportName: string,
  fallback: ReactElement = <LoadingState rows={5} />,
): ReactElement {
  const Component = lazy(async () => {
    const module = await loader();

    return { default: module[exportName] };
  });

  return (
    <Suspense fallback={fallback}>
      <Component />
    </Suspense>
  );
}
